<div [formGroup]="statesFg">
  <p class="filter-label"><strong>States</strong></p>
  <a class="select-all" (click)="toggleSelectAll()">Select All</a>
    <clr-checkbox-wrapper *ngFor="let stateOp of stateOptions">
      <input autocomplete="off" type="checkbox" clrCheckbox [value]="stateOp" [formControlName]="'state_' + stateOp"/>
      <label>{{getPrettyOperationStateName(stateOp)}}</label>
    </clr-checkbox-wrapper>
</div>
